import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export default function FAQ({ faqs = [] }) {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.28em] text-gold/80">FAQ</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl">
            Common <span className="bk-gold-text italic">Questions</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="border-b border-white/10 last:border-b-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl py-6 hover:text-gold hover:no-underline data-[state=open]:text-gold">
                <span className="flex items-start gap-4">
                  <span className="text-gold/70 text-sm font-sans tracking-[0.2em] mt-1">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{f.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-white/65 text-base leading-relaxed pb-6 pl-12 max-w-2xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
